export class AppErrors {
  errorCode!:string;
  errorMessage!:string;
  identifier!:string;
    constructor(public originalError?: any){
      this.errorCode=originalError?.error?.errorCode;
      this.errorMessage=originalError?.error?.errorMessage;
      this.identifier=originalError?.error?.identifier;
    }
}
